import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ActivityTab = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 18 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.44485 4.57896C7.44485 5.64211 6.583 6.50396 5.51985 6.50396C4.4567 6.50396 3.59485 5.64211 3.59485 4.57896C3.59485 3.51581 4.4567 2.65396 5.51985 2.65396C6.583 2.65396 7.44485 3.51581 7.44485 4.57896ZM8.44485 4.57896C8.44485 6.03748 7.37734 7.24666 5.98103 7.46781C5.98147 7.4764 5.98169 7.48504 5.98169 7.49374V9.11572C7.3466 9.36305 8.38174 10.5575 8.38174 11.9937C8.38174 13.43 7.34654 14.6245 5.98157 14.8718V16.5359C5.98157 16.8121 5.75771 17.0359 5.48157 17.0359C5.20543 17.0359 4.98157 16.8121 4.98157 16.5359V14.8803C3.59212 14.6534 2.53174 13.4474 2.53174 11.9937C2.53174 10.5401 3.59218 9.33406 4.98169 9.10712V7.49374C4.98169 7.48065 4.9822 7.46768 4.98318 7.45484C3.62407 7.20281 2.59485 6.01108 2.59485 4.57896C2.59485 2.96353 3.90442 1.65396 5.51985 1.65396C7.13528 1.65396 8.44485 2.96353 8.44485 4.57896ZM7.38174 11.9937C7.38174 13.0569 6.51989 13.9187 5.45674 13.9187C4.39359 13.9187 3.53174 13.0569 3.53174 11.9937C3.53174 10.9306 4.39359 10.0687 5.45674 10.0687C6.51989 10.0687 7.38174 10.9306 7.38174 11.9937ZM9.85388 4.60304C9.85388 4.3269 10.0777 4.10304 10.3539 4.10304H15.7465C16.0227 4.10304 16.2465 4.3269 16.2465 4.60304C16.2465 4.87919 16.0227 5.10304 15.7465 5.10304H10.3539C10.0777 5.10304 9.85388 4.87919 9.85388 4.60304ZM10.375 11.5624C10.0989 11.5624 9.875 11.7863 9.875 12.0624C9.875 12.3386 10.0989 12.5624 10.375 12.5624H15.7748C16.0509 12.5624 16.2748 12.3386 16.2748 12.0624C16.2748 11.7863 16.0509 11.5624 15.7748 11.5624H10.375Z"
        />
      </svg>
    )
  },
)

export default ActivityTab
